"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { useUser } from "@clerk/nextjs";
import { useParams } from "next/navigation";


export default  function UserDashboard({ params }) {
  // Get username from URL params
  const username = useParams().user;
  // Get user data from Clerk
  const { user } = useUser();
  
  // Example verse (would come from API/database in real implementation)
  const latestVerse = {
    text: "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.",
    reference: "John 3:16"
  };

  // Log the user email whenever save is clicked
  const handleLogUserData = () => {
    const noteObject = {
      email: user?.primaryEmailAddress?.emailAddress,
      // Example of what would be sent to the API
      title: `Bible Study Notes - ${new Date().toLocaleDateString()}`,
      content: "User Bible study data would go here"
    };
    
    console.log("Note data to be saved:", noteObject);
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      {/* User header section */}
      <div className="flex items-center gap-4 mb-8">
        <div className="w-16 h-16 relative rounded-full overflow-hidden bg-gray-200">
          <Image 
            src="/next.svg"
            alt={`${username}'s profile`}
            fill
            sizes="64px"
          />
        </div>
        <h1 className="text-2xl font-bold">Welcome, {username}!</h1>
      </div>

      {/* Latest verse display */}
      <div className="p-4 mb-6 bg-blue-50 border border-blue-100 rounded-lg">
        <h2 className="font-medium mb-2">Today's Verse</h2>
        <p className="italic text-gray-700">"{latestVerse.text}"</p>
        <p className="text-right text-sm text-gray-500 mt-2">— {latestVerse.reference}</p>
      </div>

      {/* Dashboard content */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Activity card */}
        <div className="p-4 border rounded-lg shadow-sm">
          <h2 className="font-medium mb-2">Recent Activity</h2>
          <p className="text-gray-600">No recent activity to display</p>
        </div>
        
        {/* Stats card */}
        <div className="p-4 border rounded-lg shadow-sm">
          <h2 className="font-medium mb-2">Your Stats</h2>
          <p className="text-gray-600">0 completed tasks</p>
        </div>
        
        {/* Quick links card */}
        <div className="p-4 border rounded-lg shadow-sm">
          <h2 className="font-medium mb-2">Quick Links</h2>
          <div className="flex flex-col gap-2">
            <Link href={`/${username}/settings`} className="text-blue-500 hover:underline">Settings</Link>
            <Link href={`/${username}/messages`} className="text-blue-500 hover:underline">Messages</Link>
            <Link href={`/${username}/Bible`} className="mt-2">
              <button className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition" onClick={handleLogUserData}>
                Open Bible
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}


